import { render, staticRenderFns } from "./goodsCategory.vue?vue&type=template&id=75ca1286&scoped=true&"
import script from "./goodsCategory.vue?vue&type=script&lang=js&"
export * from "./goodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./goodsCategory.vue?vue&type=style&index=0&id=75ca1286&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca1286",
  null
  
)

export default component.exports